import { App } from 'vue'
import KJsonEdit from './src/json-edit'

KJsonEdit.install = (app: App): void => {
  app.component(KJsonEdit.name, KJsonEdit)
}

export default KJsonEdit
